// @flow

import React, { Component } from "react";
import Retool from "react-retool";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import { withAcl } from "../Acl";
import { load } from "../../redux/modules/embed-retool";

type PropsType = {
    embedRetool: *,
    getEmbedUri: () => void,
    location: *,
};

class EmbedRetool extends Component<PropsType> {
    componentDidMount() {
        this.props.getEmbedUri();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.key !== this.props.location.key) {
            this.props.getEmbedUri();
        }
    }

    render() {
        const {
            embedRetool: { data, error, loading },
            location,
        } = this.props;

        if (loading || data === null) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error</div>;
        }

        return (
            <Retool
                key={location.key}
                styling={{
                    display: "block",
                    width: "100%",
                    height: "100vh",
                }}
                url={data}
            />
        );
    }
}

export default withAcl(
    withRouter(
        connect(
            ({ embedRetool }) => ({ embedRetool }),
            (dispatch: *) =>
                bindActionCreators({ getEmbedUri: load }, dispatch),
        )(EmbedRetool),
    ),
);
